import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ENERGY_ADVISOR_CUSTOMERS_KEY } from "./useEnergyAdvisorCustomers";
import { api } from "@/lib/api";
import type { Session } from "@/types/session";
import type { SetDemoModeRequest } from "@/types/users";

/**
 * Flips the caller's Demo Mode (AB#7529). The server persists the toggle on the
 * user and returns the refreshed session; we prime the session cache with it and
 * drop the cached Energy Advisor customer lists so the next read re-scopes to the
 * new (demo / production) set.
 */
export function useDemoMode() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (enabled: boolean) =>
      api.patch<Session>("/api/session/demo-mode", {
        enabled,
      } satisfies SetDemoModeRequest),
    onSuccess: (session) => {
      qc.setQueryData(["session"], session);
      qc.invalidateQueries({ queryKey: ENERGY_ADVISOR_CUSTOMERS_KEY });
    },
  });
}
